/** Фирменные логотипы Aurent — везде logonew (полный знак без фона). */
export const BRAND_LOGO_ICON = '/brand/logonew.png';
export const BRAND_LOGO_FULL = '/brand/logonew.png';
export const BRAND_NAME = 'Aurent';

export const BRAND_LOGO_SIZES = {
  iconSm: 28,
  iconMd: 36,
  iconLg: 44,
  fullSm: 28,
  fullMd: 36,
  fullLg: 48,
  fullDesktop: 36,
  /** Компактный логотип только для аптечной кассы */
  pharmacyDesktop: 22,
  pharmacyIcon: 22,
};
